import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {AgentsAlerts} from "../../../agents/services/agents-alerts.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {ServicesService} from "../../services/services-service.service";
import {LeanPlanningRequestsService} from "../../../lean-planning/services/plan-requests.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {SelectFilterType} from "../../../commons/types/select-filter.type";

export class ServicesAssignResourceAllocationDialogViewCtrl implements IController {
  serviceIds: any;
  assignAddedDeliveries: boolean;
  selectedResourceAllocationData: any;
  isForceAdding: boolean;
  hideUnroutedResources: boolean;
  onResourceAllocationSelected: Function;
  onMainVehicleChanged: Function;
  onAttachedVehicleChanged: Function;

  public services: any[];
  public loading;
  private deliveriesRef: any;
  private assignData: any;
  private queryString: any;
  public from: any;
  public to: any;
  public isfiltersInRow: boolean;
  public settings: any;
  public selectFilterType: typeof SelectFilterType = SelectFilterType;
  public branchIds: string[] = [];
  public branchIdOptions: string[] = [];

  /* @ngInject */
  constructor(private $delivery, private servicesService: ServicesService, private $log, private deliveriesService: DeliveriesService,
              private analyticsService: AnalyticsService, private leanPlanningRequestsService: LeanPlanningRequestsService,
              private agentsAlerts: AgentsAlerts, private moment, private $mdMedia, private splitService: SplitService) {
    this.deliveriesRef = this.$delivery();
  }

  $onInit() {
    this.assignData = {};
    if (this.serviceIds && this.serviceIds.length) {
      this.deliveriesRef.$asyncValues(this.serviceIds)
        .then((services) => {
          this.services = services;
          this.branchIdOptions = _.uniq(_.flatMap(this.services, 'branchIds'));
          _.forEach(services, (s) => {
            this.from = (!this.from || s.notBefore < this.from) ? this.moment(s.notBefore).startOf("day").valueOf() : this.from;
            this.to = (!this.to || s.notAfter > this.to) ? this.moment(s.notAfter).endOf("day").valueOf() : this.to;
          })

          this._setAssignData();
        })
    }

    this.settings = this.splitService.getSiteServicesAssignResourceAllocationSettings();
  }

  $doCheck() {
    this.isfiltersInRow = this.$mdMedia('(min-width: 700px)');
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onQueryStringChange(queryString) {
    this.queryString = queryString;
  }

  onChangeBranches(branchIds) {
    this.branchIds = branchIds;
    this._setAssignData();
  }

  onRangeChange(from, to) {
    if (from === this.from && to === this.to) {
      return;
    }

    this.from = from;
    this.to = to;

    if (this.from >= this.to || this.to <= this.from) {
      return;
    } else {
      this._setAssignData();
    }
  }

  onViewSettingsChange(settings) {
    this.settings = settings;
    this.splitService.setSiteServicesAssignResourceAllocationSettings(settings);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setAssignData() {
    this.loading = true;
    this.assignData = undefined;
    this.onResourceAllocationSelected({resourceAllocationData: undefined})
    this.servicesService.getAssignResourceAllocationData(this.serviceIds, this.from, this.to, undefined, this.branchIds)
      .then((data) => {
        this.assignData = data;
        this._setServicesTotals(this.services);
      })
      .catch((error) => {
        this.agentsAlerts.getManyError();
        this.$log.error('Failed to get assign data ' +
          '@servicesAssignDialogView@_setAssignData', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _setServicesTotals(services) {
    _.set(this.assignData, 'deliveriesCount', 0);
    _.set(this.assignData, 'fieldServicesCount', 0);

    _.forEach(services, (s) => {
      if (s.serviceType === 'Delivery') {
        this.assignData.deliveriesCount++;
      }
      if (s.serviceType === 'Operation') {
        this.assignData.fieldServicesCount++;
      }
    })
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesAssignResourceAllocationDialogView', {
    bindings: {
      serviceIds: '<',
      isForceAdding: '<?',
      selectedResourceAllocationData: '<?',
      assignAddedDeliveries: '<?',
      hideUnroutedResources: '<?',
      onResourceAllocationSelected: '&',
      onMainVehicleChanged: '&',
      onAttachedVehicleChanged: '&',
      onForceAddingChanged: '&',
    },
    template: require('./services-assign-resource-allocation-dialog-view.html').default,
    controller: ServicesAssignResourceAllocationDialogViewCtrl
  });
